import { Button, Icon24ArrowRight, Typography } from "@cur8/maneki";
import { useClearRoomControllerMutation } from "hooks/mutations/useClearRoomControllerMutation";
import { useCompleteVisitMutation } from "hooks/mutations/useCompleteVisitMutation";
import { useCallback } from "react";
import { paths } from "render/routes/paths";
import { InformationLayout } from "render/ui/layout/InformationLayout/InformationLayout";
import { PageFrameContent } from "render/ui/layout/PageFrameContent/PageFrameContent";

type CheckOutViewProps = {
  goTo(url: string): void;
  patientId: string;
  visitId: string;
};

export function CheckOutView({ goTo, patientId, visitId }: CheckOutViewProps) {
  const clearRoomController = useClearRoomControllerMutation();
  const completeVisit = useCompleteVisitMutation();

  const handleContinue = useCallback(async () => {
    try {
      await Promise.all([
        clearRoomController.mutateAsync({ patientId, visitId }),
        completeVisit.mutateAsync({ patientId, visitId }),
      ]);
      goTo(paths.root.url({}));
    } catch {
      // errors surface via useReporting.logError in each hook; stay on screen
    }
  }, [clearRoomController, completeVisit, goTo, patientId, visitId]);

  const isCheckingOut =
    clearRoomController.isPending || completeVisit.isPending;

  return (
    <PageFrameContent>
      <InformationLayout
        content={
          <>
            <Typography variant="display-s">Ready to check-out?</Typography>
            <Typography variant="body-m" color="subtle">
              Check out if all examinations are complete
            </Typography>
          </>
        }
        buttons={
          <Button
            onPress={handleContinue}
            fillContainer
            icon={<Icon24ArrowRight />}
            state={isCheckingOut ? "loading" : undefined}
          >
            Check-out
          </Button>
        }
      />
    </PageFrameContent>
  );
}
